import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Input } from './input';

interface SearchInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	className?: string;
}

export function SearchInput({
	value,
	onChange,
	placeholder = 'Search…',
	className,
}: SearchInputProps) {
	return (
		<div className={cn('relative min-w-0', className)}>
			<Search
				size={14}
				className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-text-4"
			/>
			<Input
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				className="h-8 w-full border-line-2 bg-surface-input pl-9 pr-8 text-xs"
			/>
			{value && (
				<button
					type="button"
					onClick={() => onChange('')}
					className="absolute right-2 top-1/2 flex h-4 w-4 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full text-text-4 transition-colors hover:bg-surface-hover hover:text-text-2"
				>
					<X size={12} />
				</button>
			)}
		</div>
	);
}
